import React from 'react'
import BackButtonButton from './BackButton'
import NextStepButton from './NextStepButton'
import {usePurchaseForm} from './PurchaseFormProvider'
import {BlockComponentProps} from '../index'
import CountrySelect from '../../lib/ui/CountrySelect'
import StateSelect from '../../lib/ui/StateSelect'
import {PurchaseFormBlock} from '.'
import {useSection} from '../../Section'
import styles from './PurchaseForm.module.css'
import {usePurchase} from '../../PurchaseContext'
import {ErrorBox} from '../PurchaseForm/CustomerDetailStep'

interface ShippingAddressStepProps extends PurchaseFormBlock {
  sectionId?: string
  onBack: () => void
  onContinue: () => void
  TextFieldComponent: React.FC<any>
  ButtonComponent: React.FC<any>
}

export default function ShippingAddressStep(
  props: ShippingAddressStepProps & BlockComponentProps,
) {
  const {
    onBack,
    onContinue,
    TextFieldComponent,
    ButtonComponent,
    ...config
  } = props
  const {
    input: {spacing},
    buttonStyle,
    buttonsAlignment,
  } = config

  const {
    shippingCountryId: countryId,
    shippingAddress1,
    setShippingAddress1,
    shippingAddress1Error,
    shippingAddress2,
    setShippingAddress2,
    setShippingCountryId,
    shippingCountryIdError,
    shippingStateId,
    setShippingStateId,
    shippingStateIdError,
    shippingCity,
    setShippingCity,
    shippingCityError,
    shippingZipPostal,
    setShippingZipPostal,
    shippingZipPostalError,
    validatShippingForm,
    hasError,
  } = usePurchaseForm()

  const {calculateVisibility} = useSection()
  const {selectedTicket} = usePurchase()

  const handleContinue = async () => {
    const valid = selectedTicket?.shipping_address_required
      ? validatShippingForm(config)
      : true
    if (valid) {
      onContinue()
    } else {
      calculateVisibility()
    }
  }

  const selectorsClass = `country-state-selector`

  return (
    <>
      <style>
        {`
        .${selectorsClass} {
          margin-bottom: 0px;
        }

        .${selectorsClass} > div > div {
          background-color: ${config.input.backgroundColor};
          border: ${config.input.border.width}px solid;
          border-color: ${config.input.border.color};
          border-radius: ${config.input.border.radius}px !important;
          padding-left: ${config.input.padding.left}px;
          padding-right: ${config.input.padding.right}px !important;
          padding-top: ${config.input.padding.top}px;
          padding-bottom: ${config.input.padding.bottom}px;
          font-size: ${config.input.fontSize}px;
          line-height: normal;
        }

        .${selectorsClass} > div > div:focus {
          background-color: ${config.input.backgroundColor};
        }
     
        `}
      </style>
      <div>
        <div>
          <div>
            <TextFieldComponent
              aria-label={`shipping_address address 1`}
              config={config}
              placeholder={'shippingAddress1'}
              value={shippingAddress1}
              onChange={(e: any) => setShippingAddress1(e)}
              error={!!shippingAddress1Error}
            />
          </div>
          <div>
            <TextFieldComponent
              aria-label={`shipping_address address 2`}
              config={config}
              placeholder={'shippingAddress2'}
              value={shippingAddress2}
              onChange={(e: any) => setShippingAddress2(e)}
            />
          </div>
          <div>
            <CountrySelect
              config={config}
              className={selectorsClass}
              value={countryId}
              onChange={(value) => setShippingCountryId(value)}
              defaultLabel={config.input.placeholder.shippingcountry}
              error={!!shippingCountryIdError}
            />
          </div>
          <div>
            <StateSelect
              config={config}
              className={selectorsClass}
              value={shippingStateId}
              onChange={(value) => setShippingStateId(value)}
              countryId={countryId}
              defaultLabel={config.input.placeholder.shippingstate}
              error={!!shippingStateIdError}
            />
          </div>
          <div>
            <TextFieldComponent
              aria-label={`shipping_address city`}
              config={config}
              placeholder={'shippingcity'}
              name={`shipping_address.city`}
              value={shippingCity}
              onChange={(e: any) => setShippingCity(e)}
              error={!!shippingCityError}
            />
          </div>
          <div>
            <TextFieldComponent
              aria-label={`shipping_address postal`}
              config={config}
              placeholder={'shippingzipcode'}
              name={`shipping_address.zip_postal`}
              value={shippingZipPostal}
              onChange={(e: any) => setShippingZipPostal(e)}
              error={!!shippingZipPostalError}
            />
          </div>
        </div>
        <ErrorBox showError={hasError} config={config} />
        <div>
          <div
            className={styles.formButtonBox}
            style={{
              gap: '15px',
              marginTop: spacing,
              justifyContent: buttonsAlignment,
            }}
          >
            <BackButtonButton {...config} onClick={onBack} />
            <div
              className={styles.purchaseFormButtonHolder}
              style={{width: buttonStyle.width + '%'}}
            >
              <NextStepButton
                ButtonComponent={ButtonComponent}
                {...config}
                onClick={handleContinue}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
